module.exports = __webpack_public_path__ + "2c2b577fdfdc1e7c533dd4cbd39a9926.png";